import type { Level } from "./types";

/**
 * Stars for a labyrinth given the longest forced path the player achieved:
 *   3 — matched the proven-best (opt is the exact maximum, so "≥" binds only at
 *       equality — levels.test.ts proves it)
 *   2 — reached the 2-star threshold (a strong, deliberate barrier)
 *   1 — lengthened the hero's path at all (beat the open `base`)
 *   0 — added nothing useful (still the open shortest path, or no walls)
 * All lengths are integer step counts, so exact comparisons are safe.
 */
export function starsFor(level: Level, bestLength: number): number {
  if (bestLength >= level.opt) return 3;
  if (bestLength >= level.twoStar) return 2;
  if (bestLength > level.base) return 1;
  return 0;
}
